import index from './views/index.vue'
import helpcenter from './views/helpcenter.vue'
import help from './views/help.vue'
import aboutus from './views/aboutus.vue'
import helpdetail from './views/helpdetail.vue'
import loancontract from './views/loancontract.vue'
import contract from './views/contract.vue'
import perauthorize from './views/perauthorize.vue'
import percontract from './views/percontract.vue'
import persh from './views/persh.vue'
import agreement from './views/agreement.vue'
import authcontract from './views/authcontract.vue'
import privacy from './views/privacy.vue'
import aboutdetail from './views/aboutdetail.vue'
import advicecontract from './views/advicecontract.vue'
import paycontract from './views/paycontract.vue'
import contractlist from './views/contractlist.vue'
import protocollist from './views/protocollist.vue'
import loanlist from './views/loanlist.vue'
import docagree from './views/docagree.vue'
import mgmindex from './views/mgmindex.vue'
import mgmshare from './views/mgmshare.vue'
import indexlist from './views/indexlist.vue'
import cashlist from './views/cashlist.vue'
import creditlist from './views/creditlist.vue'
import scanagreement from './views/scanagreement.vue'
import quickpass from './views/quickpass.vue'
import xhcd from './views/xhcd.vue'
import zakj from './views/zakj.vue'
import covertext from './views/covertext.vue'
const routes = [
    {
        path: '/',
        name: 'index',
        component: index
    }, {
        path: '/helpcenter',
        name: 'helpcenter',
        component: helpcenter
    }, {
        path: '/help',
        name: 'help',
        component: help
    }, {
        path: '/aboutus',
        name: 'aboutus',
        component: aboutus
    }, {
        path: '/helpdetail',
        name: 'helpdetail',
        component: helpdetail
    }, {
        path: '/loancontract',
        name: 'loancontract',
        component: loancontract
    }, {
        path: '/contract',
        name: 'contract',
        component: contract
    }, {
        path: '/perauthorize',
        name: 'perauthorize',
        component: perauthorize
    }, {
        path: '/percontract',
        name: 'percontract',
        component: percontract
    }, {
        path: '/persh',
        name: 'persh',
        component: persh
    }, {
        path: '/agreement',
        name: 'agreement',
        component: agreement
    }, {
        path: '/authcontract',
        name: 'authcontract',
        component: authcontract
    }, {
        path: '/privacy',
        name: 'privacy',
        component: privacy
    }, {
        path: '/aboutdetail',
        name: 'aboutdetail',
        component: aboutdetail
    }, {
        path: '/advicecontract',
        name: 'advicecontract',
        component: advicecontract
    }, {
        path: '/paycontract',
        name: 'paycontract',
        component: paycontract
    }, {
        path: '/contractlist',
        name: 'contractlist',
        component: contractlist
    }, {
        path: '/protocollist',
        name: 'protocollist',
        component: protocollist
    }, {
        path: '/loanlist',
        name: 'loanlist',
        component: loanlist
    }, {
        path: '/docagree',
        name: 'docagree',
        component: docagree
    },
    {
        path: '/mgmindex',
        name: 'mgmindex',
        component: mgmindex
    },
    {
        path: '/mgmshare',
        name: 'mgmshare',
        component: mgmshare
    },
    {
        path: '/indexlist',
        name: 'indexlist',
        component: indexlist
    },
    {
        path: '/cashlist',
        name: 'cashlist',
        component: cashlist
    },
    {
        path: '/creditlist',
        name: 'creditlist',
        component: creditlist
    },
    {
        path: '/scanagreement',
        name: 'scanagreement',
        component: scanagreement
    },
    {
        path: '/quickpass',
        name: 'quickpass',
        component: quickpass
    },
    {
        path: '/xhcd',
        name: 'xhcd',
        component: xhcd
    },
    {
        path: '/zakj',
        name: 'zakj',
        component: zakj
    },
    {
        path: '/covertext',
        name: 'covertext',
        component: covertext
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js